import React from "react";
import style from "./Loader.module.css";

export const Loader = () => {
  return (
    <div className={style.loader} role="status" aria-live="polite">
      <div className={style.spinner} aria-hidden="true" />
      <span className={style.srOnly}>Sending…</span>
    </div>
  );
};
